import { UnitNamesProvider } from "../components/UnitNames";
import LookupProvider from "../lookups/LookupProvider";
import type { ReactNode } from "react";
import ApiInterceptor from "../api/ApiInterceptor";
import AuthProvider from "../auth/AuthProvider";
import { BusyIndicatorProvider } from "../contexts/BusyIndicatorContext";
import { ErrorProvider } from "../contexts/ErrorContext";
import TenantProvider from "../tenant/TenantProvider";
import WarehouseProvider from "../warehouse/WarehouseProvider";
import TenantThemeProvider from "../tenant/TenantThemeProvider";

interface AppProvidersProps {
  children: ReactNode;
}

export default function AppProviders({ children }: AppProvidersProps) {
  return (
    <ErrorProvider>
      <BusyIndicatorProvider>
        <TenantProvider>
          <TenantThemeProvider>
            <AuthProvider>
              <ApiInterceptor />
              <UnitNamesProvider><WarehouseProvider><LookupProvider>{children}</LookupProvider></WarehouseProvider></UnitNamesProvider>
            </AuthProvider>
          </TenantThemeProvider>
        </TenantProvider>
      </BusyIndicatorProvider>
    </ErrorProvider>
  );
}
